<template>
  <component :is="lang" />
</template>

<script>
import de from 'beisheim/assets/images/icons/flags/flag-de.svg'
import ch from 'beisheim/assets/images/icons/flags/flag-ch.svg'

export default {
  name: 'FlagIcon',
  components: {
    de,
    ch
  },
  props: {
    lang: {
      type: String,
      default: () => 'de'
    }
  }
}
</script>
